
function bio() {
  return (
    <div className="container-xl text-center my-5 " id="biot">
      
      <figure class="text-center">
  <blockquote class="blockquote">
  <p className="lead display-6 " >
        <p className="text-center display-5">About Me</p>
        Self-motivated, highly passionate, and hardworking fresher looking for
        an opportunity to work in a challenging organization to utilize my
        skills and knowledge to work for the growth of the organisation.
        <br />
        A highly technical and knowledgeable Software Engineer, seeking an
        entry-level position in an organization that offers good growth
        prospects. <br />
        Have an internship experience of 3 months and advanced knowledge of
        programming as well as UI and UX designing.
      </p>
  </blockquote>
  <figcaption class="blockquote-footer">
    Ravendra Patel<cite title="Source Title"></cite>
  </figcaption>
</figure>

      
    </div>
  );
}
export default bio;
